import dayjs from 'dayjs';

export const money = (value) =>
  value === null || value === undefined
    ? '—'
    : Number(value).toLocaleString('sr-RS', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const date = (value) => (value ? dayjs(value).format('DD.MM.YYYY') : '—');

/** Tag colour per payment status; overdue ones are the red ones. */
export const STATUS_COLORS = {
  paid: 'green',
  partial: 'volcano',
  unpaid: 'red',
  not_due: 'blue',
  no_statement: 'default',
  pending_entry: 'gold',
};

export const STATUSES = Object.keys(STATUS_COLORS);

/** The „Interest" filter of the returns list: none, not paid, paid, typed from the tax portal. */
export const INTEREST_FILTERS = ['none', 'unpaid', 'paid', 'manual'];

/** What a return is for; a notice does not say it, so it is picked on import or set later. */
export const CATEGORIES = ['salary', 'transport', 'rent', 'other_income', 'other'];

/** Withholding tax calculations HLB makes on the platform. */
export const CALC_KINDS = ['rent', 'other_income', 'supplementary_work'];

/** Tag colour per kind of calculation. */
export const CALC_KIND_COLORS = { rent: 'purple', other_income: 'magenta', supplementary_work: 'gold' };

/** Currencies an amount can be agreed in; the others go through the NBS middle rate. */
export const CURRENCIES = ['EUR', 'USD', 'CNY', 'RSD'];
export const CURRENCY_OPTIONS = CURRENCIES.map((v) => ({ value: v, label: v }));

export const CATEGORY_COLORS = {
  salary: 'geekblue',
  transport: 'cyan',
  rent: 'purple',
  other_income: 'magenta',
  other: 'default',
};

export const saveBlob = (blob, fileName) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const errorText = (t, error) => {
  const key = error?.response?.data?.message || error?.message || '';
  return t(`errors.${key.replace(/^tax_returns\./, '')}`, { defaultValue: key });
};

/** Lower case without diacritics, so „djordja" finds „Đorđa". */
export const fold = (v) =>
  String(v || '')
    .toLowerCase()
    .replace(/đ/g, 'dj')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

/** `08-10/2026`, or `11/2026-01/2027` across the new year: the months a rent paid in a month covers. */
export const coveredPeriodOf = (month, year, months) => {
  if (!month || !year) return null;
  const pad = (m) => String(m).padStart(2, '0');
  const n = Math.max(1, Number(months) || 1);
  const end = dayjs(`${year}-${pad(month)}-01`).add(n - 1, 'month');
  if (n === 1) return `${pad(month)}/${year}`;
  return end.year() === year
    ? `${pad(month)}-${pad(end.month() + 1)}/${year}`
    : `${pad(month)}/${year}-${pad(end.month() + 1)}/${end.year()}`;
};
